
import React from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Target, BarChart, Shield, Brain, Zap, Lock, Check } from 'lucide-react';

const FeatureCard = ({ icon: Icon, title, items }: { icon: any, title: string, items: string[] }) => (
  <Card className="border-primary/20">
    <CardHeader>
      <Icon className="h-8 w-8 text-primary mb-3" />
      <h3 className="text-lg font-medium mb-0 pb-0">{title}</h3>
    </CardHeader>
    <CardContent>
      <ul className="p-0 m-0 space-y-2">
        {items.map((item, index) => (
          <li key={index} className="text-left flex items-start gap-2">
            <Check className="h-4 w-4 text-primary shrink-0 mt-1" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </CardContent>
  </Card>
);

const EnterpriseFeaturesGrid = () => {
  const features = [
    {
      icon: Target,
      title: "Board‑Level Alignment",
      items: [
        "Translate financial targets into reward schemas",
        "Executive workshops to align goals from day one"
      ]
    },
    {
      icon: BarChart,
      title: "Outcome‑Driven Evaluation",
      items: [
        "Custom scorecards measure business impact in real time",
        "Live dashboards keep leadership informed"
      ]
    },
    {
      icon: Shield,
      title: "Continuous Governance",
      items: [
        "Proactive drift detection and policy tuning",
        "Integration with your existing GRC stack"
      ]
    },
    {
      icon: Brain,
      title: "Elite RL Expertise",
      items: [
        "Core team expertise on RL for large-scale production systems",
        "Optimized to operate within current enterprise architecture"
      ]
    },
    {
      icon: Zap,
      title: "Cost Efficiency at Scale",
      items: [
        "Reduce compute spend up to 40%",
        "Dedicated clusters cut cloud overhead"
      ]
    },
    {
      icon: Lock,
      title: "Secure Deployment",
      items: [
        "VPC, on‑prem, or SOC 2‑Type II cloud",
        "Comprehensive audit trails"
      ]
    }
  ];

  return (
    <section className="py-5">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 mt-0 pt-0">
        {features.map((feature, index) => (
          <FeatureCard key={index} {...feature} />
        ))}
      </div>
    </section>
  );
};

export default EnterpriseFeaturesGrid;
